import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ShoperConnectService } from "../shoper-connect.service";
import { TokenResponse } from "../shoper-connect.model";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { AmplitudeService } from 'app/utils/amplitude.service';

@Component({
  selector: "cc-otp",
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class OtpComponent implements OnInit {
  currentStep: "PHONE_NUMBER" | "VERIFICATION" = "PHONE_NUMBER";
  phoneNumber: string;
  loading = false;
  errorMessage = "";
  verificationRequestNumber = 0;

  otpForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private service: ShoperConnectService,
    private route: ActivatedRoute,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.otpForm = this.fb.group({
      phoneNumber: [""],
      validationCode: [""],
    });

    this.updateHeadMeta();
  }

  allowToVerify({ phoneNumber }: { phoneNumber: string }) {
    if (this.loading) return;
    this.errorMessage = "";
    this.loading = true;
    this.service.verifyMsisdn(phoneNumber).subscribe(
      () => {
        this.loading = false;
        this.phoneNumber = phoneNumber;
        this.verificationRequestNumber++;
        this.currentStep = "VERIFICATION";
      },
      (error: unknown) => {
        this.errorMessage = this.requestError(error, "Podaj poprawny numer telefonu.");
        this.amplitudeService.logEvent('Shoper:SSO:Login failed', { phoneNumber } );
        this.loading = false;
      }
    );
  }

  verifyPhoneNumber({ code }: { code: string }) {
    if (!code || this.loading) return;
    this.errorMessage = "";
    this.loading = true;

    // TODO: fix SSO frontend build process to NOT overwrite qa13 build dist by prod
    const redirectUri =
      this.route.snapshot.queryParams["redirect_uri"] ||
      `${
        window.location.hostname === "qa13-sso.aws-whitelabel.ch"
          ? "https://qa13-app.aws-whitelabel.ch"
          : environment.SHOPER_CONNECT_URL
      }/login`;

    this.service.verifyCode(this.phoneNumber, code, redirectUri).subscribe(
      (token: TokenResponse) => {
        this.loading = false;
        window.location.href = `${redirectUri}?access_token=${token.accessToken}`;
      },
      (error: unknown) => {
        this.errorMessage = this.requestError(error, "Niepoprawny lub wygasły kod. Spróbuj ponownie.");
        this.amplitudeService.logEvent('Shoper:SSO:Wrong code' );
        this.loading = false;
      }
    );
  }

  restartFlow() {
    if (this.loading) return;
    this.currentStep = "PHONE_NUMBER";
    this.loading = false;
    this.errorMessage = "";
  }

  private requestError(error: unknown, invalidInputMessage: string): string {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 429) return "Zbyt wiele prób. Spróbuj ponownie później.";
      if (error.status === 400) return invalidInputMessage;
    }
    return "Nie udało się połączyć. Spróbuj ponownie później.";
  }

  private updateHeadMeta() {
    document.title = "Shoper Connect";
    (document.querySelector("#favicon") as HTMLLinkElement).href =
      "assets/img/shoper-connect/favicon.png";
  }
}
